( function(root, factory) {
        if ( typeof define === 'function' && define.amd) {
            define('mmc.libs.FormValidation',['jquery'], factory);
        } else {
            if ( typeof root.MMCLIBS === 'object') {
                root.MMCLIBS.FormValidation = factory(root.$);
            } else {
                root.FormValidation = factory(root.$);
            }
        }
    }(this, function($) {
        var FormValidation = (function() {

            var _defaults = {
                errorClass : 'error',
                getErrorElement : function($formfield) {
                    return $formfield.closest('.form-field');
                },
                errorAction : function($formfield, valid, options) {
                    if (valid === false) {
                        options.getErrorElement($formfield).addClass(options.errorClass);
                    } else {
                        options.getErrorElement($formfield).removeClass(options.errorClass);
                    }
                },
                validators : {
                    email : function($formfield) {
                        var elementValue = $formfield.val();
                        var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                        return pattern.test(elementValue);
                    },
                    url : function($formfield) {
                        var elementValue = $formfield.val();
                        var pattern = /^(http|https)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?$/;
                        return pattern.test(elementValue);
                    },
                    number : function($formfield) {
                        var elementValue = $formfield.val();
                        return !isNaN(parseFloat(elementValue)) && isFinite(elementValue);
                    },
                    integer : function($formfield) {
                        var elementValue = $formfield.val();
                        return !isNaN(parseInt(value, 10)) && (parseFloat(value, 10) == parseInt(value, 10));
                    },
                    file_image : function($formfield) {
                        if ($formfield[0].files) {
                            var file = $formfield[0].files[0];
                            if (!file.type.match(/image.*/)) {
                                return false;
                            } else
                                return true;
                        } else {
                            var path = $formfield[0].value;
                            var ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase();
                            var attr_dataAllowedExt = $formfield.attr('data-allowed-ext');
                            var allowedExt = typeof attr_dataAllowedExt === 'string' ? attr_dataAllowedExt.split(',') : ['gif', 'jpeg', 'jpg', 'png'];
                            for (var i = 0; i < allowedExt.length; i++) {
                                allowedExt[i] = $.trim(allowedExt[i]);
                            }
                            if ($.inArray(ext, allowedExt) > -1) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    file_document : function($formfield) {
                        var path = $formfield[0].value;
                        var ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase();
                        var attr_dataAllowedExt = $formfield.attr('data-allowed-ext');
                        var allowedExt = typeof attr_dataAllowedExt === 'string' ? attr_dataAllowedExt.split(',') : ['pdf', 'doc', 'docx'];
                        for (var i = 0; i < allowedExt.length; i++) {
                            allowedExt[i] = $.trim(allowedExt[i]);
                        }
                        if ($.inArray(ext, allowedExt) > -1) {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    file_video : function($formfield) {
                        var path = $formfield[0].value;
                        var ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase();
                        var attr_dataAllowedExt = $formfield.attr('data-allowed-ext');
                        var allowedExt = typeof attr_dataAllowedExt === 'string' ? attr_dataAllowedExt.split(',') : ['mov', 'mpeg', 'mpeg4', 'mp4', 'avi', 'wmv', 'flv', '3gp', 'webm', 'mkv', 'swf', 'aac', 'm4v'];
                        for (var i = 0; i < allowedExt.length; i++) {
                            allowedExt[i] = $.trim(allowedExt[i]);
                        }
                        if ($.inArray(ext, allowedExt) > -1) {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    pattern : function($formfield) {
                        var elementValue = $formfield.val();
                        var pattern = new RegExp( '^(?:' + $formfield.attr('pattern')  + ')$' );
                        return pattern.test(elementValue);
                    },                    
                }
            };

            /**
             * validates each form field an returns an array containing the invalid fields
             *
             * @method public
             * @param formDomObject - DOM object || jQuery object
             * @param customOptions - object
             *
             * @return object
             */
            var validateForm = function(formDomObject, customOptions) {
                customOptions = customOptions || {};
                var options = $.extend(true, {}, _defaults, customOptions);

                var $form = $(formDomObject);
                var invalidFields = [];

                $form.find('input, textarea, select').each(function() {
                    var $formfield = $(this);
                    if (validateFormField($formfield, options) === false) {
                        invalidFields.push($formfield);
                    }
                    $formfield.one('change', function() {
                        options.getErrorElement($(this)).removeClass(options.errorClass);
                    });
                });

                return invalidFields;
            };

            /**
             * validates a single form field
             *
             * @method public
             * @param $formfield - jQuery object
             * @param customOptions - object
             *
             * @return boolean
             */
            var validateFormField = function($formfield, customOptions) {
                customOptions = customOptions || {};
                var options = $.extend(true, {}, _defaults, customOptions);

                options.getErrorElement($formfield).removeClass(options.errorClass);

                var valid = true;
                var attr_dataInputType = $formfield.attr('data-input-type');
                var attr_type = $formfield.attr('type');
                var type = typeof attr_dataInputType !== 'undefined' && attr_dataInputType !== false ? attr_dataInputType : attr_type;
                var attr_dataMaxFilesize = $formfield.attr('data-max-filesize');
                var value = $formfield.val();
                if (value !== '') {
                    if ( typeof options.validators[type] === 'function' && !options.validators[type]($formfield)) {
                        valid = false;
                    }

                    if (attr_type === 'file' && $formfield[0].files && !isNaN(attr_dataMaxFilesize)) {
                        var files = $formfield[0].files;
                        for (var i = 0; i < files.length; i++) {
                            if (files[i].size && files[i].size > parseInt(attr_dataMaxFilesize, 10)) {
                                valid = false;
                                continue;
                            }
                        }
                    }

                    if ( $formfield.is('[pattern]') ) { 
                        if ( typeof options.validators.pattern === 'function' && !options.validators.pattern($formfield)) {
                            valid = false;
                        }                        
                    }

                    if ($formfield.is('[data-input-minlength]')) {
                        var minlength = $formfield.attr('data-input-minlength');
                        if (value.length < minlength) {
                            valid = false;
                        }
                    }

                    var min = $formfield.attr('min');
                    var max = $formfield.attr('max');
                    if ($formfield.is('[min]') && parseInt(value, 10) < min) {
                        valid = false;
                    }
                    if ($formfield.is('[max]') && parseInt(value, 10) > max) {
                        valid = false;
                    }
                }
                if ($formfield.is('[required]')) {
                    if ($formfield.attr('type') === 'radio' || $formfield.attr('type') === 'checkbox') {
                        
                        valid = false;

                        $('[name="' + $formfield.attr('name') + '"]').each(function() {
                            if ($(this).is(':checked')) {
                                valid = true;
                            }
                        });
                    } else if ($.trim($formfield.val()) === '' || $formfield.val() === $formfield.attr('placeholder')) {
                        valid = false;
                    }
                }
                options.errorAction($formfield, valid, options);

                return valid;
            };

            /**
             * @method public
             * @param yyyy - String
             * @param mm - String
             * @param dd - String
             *
             * @return boolean
             */
            var validateDate = function(yyyy, mm, dd) {
                var d = new Date(mm + "/" + dd + "/" + yyyy);
                return d.getMonth() + 1 == mm && d.getDate() == dd && d.getFullYear() == yyyy;
            };

            /**
             * @method public
             * @param birthYear - String
             * @param birthMonth - String
             * @param birthDay - String
             *
             * @return boolean
             */
            var getAgeByYearMonthDay = function(birthYear, birthMonth, birthDay) {
                var birthDate = new Date(birthYear, birthMonth - 1, birthDay);
                return getAge(birthDate);
            };

            /**
             * @method public
             * @param birthDate - Date object
             *
             * @return boolean
             */
            var getAge = function(birthDate) {
                var today = new Date();
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;
            };

            return {
                validateForm : validateForm,
                validateFormField : validateFormField,
                validateDate : validateDate,
                getAgeByYearMonthDay : getAgeByYearMonthDay,
                getAge : getAge
            };

        })();
        return FormValidation;
    }));

